"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlwaysActiveLinks = void 0;
var _net = require("./graphql-types/net");
const AlwaysActiveLinks = exports.AlwaysActiveLinks = [_net.NavigationLinkType.Catalogue];